import * as api from "@/services/api";

const errorSnackbar = (commit, message) => {
  commit("ui/setSnackbar", { variant: "danger", title: "Error", message }, { root: true });
};

export const fetchPaymentTypes = async ({ commit }) => {
  try {
    const response = await api.get("/company-payments/payment-types");
    if (response.data.code == 200) {
      commit("init", response.data.data);
    } else {
      errorSnackbar(commit, "Error Fetching Payment Types");
    }
  } catch (error) {
    errorSnackbar(commit, "Error Fetching Payment Types");
  }
};

export const createPaymentType = async ({ commit }, payload) => {
  try {
    const response = await api.post("/company-payments/payment-types", payload);
    // 201 = created, 200 = existing/restored match (deduped server-side)
    if (response.data.code == 200 || response.data.code == 201) {
      commit("addPaymentType", response.data.data.paymentType);
    } else {
      errorSnackbar(commit, "Error Creating Payment Type");
    }
    return response.data.data?.paymentType;
  } catch (error) {
    errorSnackbar(commit, "Error Creating Payment Type");
    return null;
  }
};

export const updatePaymentType = async ({ commit }, payload) => {
  try {
    const response = await api.patch(`/company-payments/payment-types/${payload.paymentType.id}`, payload);
    if (response.data.code == 200) {
      commit("updatePaymentType", response.data.data.paymentType);
    } else {
      errorSnackbar(commit, "Error Updating Payment Type");
    }
    return response.data.data?.paymentType;
  } catch (error) {
    errorSnackbar(commit, "Error Updating Payment Type");
    return null;
  }
};

export const deletePaymentType = async ({ commit }, payload) => {
  try {
    const response = await api.destroy(`/company-payments/payment-types/${payload.id}`);
    if (response.data.code == 200) {
      commit("processDeletedPaymentType", response.data.data.paymentType);
    } else {
      errorSnackbar(commit, "Error Deleting Payment Type");
    }
    return response.data.data?.paymentType;
  } catch (error) {
    errorSnackbar(commit, "Error Deleting Payment Type");
    return null;
  }
};
